export default {
	SeatReservation: 1,			// NO LONGER EXISTS AS UI STAGE (as of hops#567)
	Addons: 2,
	CustomerDetails: 3,
	GiftAid: 4,
	PaymentDetails: 5,
	Submit: 6
};
